export default __webpack_public_path__ + "static/forests-img-8ae869561e6f328cc15be765ae51fec9.jpg";